import { InjectionToken } from '@angular/core';

/** Identifies the pinned bundle a placed custom widget renders. */
export interface CustomWidgetPreviewUrlRequest {
  /** The widget's registry slug, as persisted in `widgetProperties.customWidget.widgetId`. */
  widgetId: string;
  version: string;
}

export interface CustomWidgetPreviewUrlResolver {
  /** A loadable runner URL for this widget/version, or undefined to fall back to `bundleUrl`. */
  resolve(request: CustomWidgetPreviewUrlRequest): string | undefined;
}

/**
 * Optional, builder-only seam for locating a widget's runner.
 *
 * A placed widget's persisted `bundleUrl` is `/assets/custom-widgets/<slug>/<version>/runner.html`,
 * which exists only in a deployed project's own web-frontend (nginx proxies it to blob storage).
 * The app builder is a different app on a different origin with no such route, so its canvas
 * preview would 404 forever. The builder provides this token to point the preview frame at the
 * provisioner's bundle route instead.
 *
 * Nothing provides it in production, and the widget component only consults it in builder mode,
 * so the deployed app's behaviour is byte-for-byte what it was. The resolved URL is used at
 * render time only — it is never written back into the widget config.
 */
export const CUSTOM_WIDGET_PREVIEW_URL_RESOLVER = new InjectionToken<CustomWidgetPreviewUrlResolver>(
  'CUSTOM_WIDGET_PREVIEW_URL_RESOLVER',
);
